import {Injectable, Injector} from '@angular/core';
import {AuthorityBaseService} from './authority-base.service';
import {Observable, throwError} from 'rxjs';
import {catchError, map, tap} from 'rxjs/operators';
import {WorkingTypes} from '../models/enums.model';
import {Response} from '@angular/http';
import { DossierModel } from '../models/dossier.model';
import { CarglassRequestDetail } from '@app/authority/authority-ald/models/glass-request-detail.model';
import { DossierWorking } from '../models/dossier-working.model';
import { WorkingModel } from '../models/working.model';
import { Utilities as U, Utilities } from '@app/shared/utilities/utilities.model';
import { CarglassRequest } from '@app/authority/authority-ald/models/glass-request.model';

@Injectable({
	providedIn: 'root'
})

/* tslint:disable:no-unnecessary-callback-wrapper */
export class AuthorityChannelingService extends AuthorityBaseService {

	private baseUrl: string = `${this.environment.AUTHORITY}/working_channeling`;

	constructor(protected injector: Injector) {
		super(injector);
	}

	// getBaseURL(x: EModuleType, dossier?: DossierModel | CarglassRequestDetail | DossierWorking): string {
	// 	return dossier && dossier.isArchived() ? this.environment.api[x].historical.v1 : this.environment.api[x].v1;
	// }
	getBaseURL(type: EModuleType, x?: boolean | DossierModel | CarglassRequestDetail | DossierWorking): string {

		const api = this.environment.api[type];

		if (Utilities.isEmpty(x) || x === false) {
			return api.v1;
		}

		if (x == true) {
			return api.historical.v1;
		}
		
		if (x instanceof DossierModel || x instanceof CarglassRequestDetail || x instanceof DossierWorking) {
			return x && x.isArchived() ? api.historical.v1 : api.v1;
		}
		
		return this.environment.api[type].v1;
	}
	
	getUsersGroup(): Observable<UserGroup[]> {
		return this.httpAuthService.get(`${this.baseUrl}/groups`, this.redirectUrl).pipe(
			tap(response => {
				if (!response.ok) {
					throw response;
				}
			}), map(response => response.json().user_groups),
			catchError(err => throwError(err))
		);
	}

	getUsersByGroups(groupId: string): Observable<User[]> {
		return this.httpAuthService.get(`${this.baseUrl}/groups/${groupId}/users`, this.redirectUrl).pipe(
			tap(response => {
				if (!response.ok) {
					throw response;
				}
			}), map(response => response.json().users),
			catchError(err => throwError(err))
		);
	}

	// TODO
	// se va canalizzata la pratica anche per historical

	// non va bene ForcedChannelingRequest
	// va cambiata con una struttura dati
	// che ha dentro l'entità pratica

	// forceChanneling(request: ForcedChannelingRequest, isForGlassPractice?: boolean): Observable<Response> { 
	// 	const url = (isForGlassPractice ? this.getBaseURL(EModuleType.CARGLASS, dossier)+'/channeling' : this.getBaseURL(EModuleType.AUTHORITY, dossier)+'/working_channeling') + '/association/forced';
		
	// il problema è che viene presa una lista di string, con dentro i vari workings_id
	// bisogna fare una cambio strutturale perché non posso memorizzare is_archived 

		// TODO
		// bisogna fare lo split delle pratiche ATTIVE e ARCHIVIATE
		// e fare 2 post diverse, una verso authority e l'altra verso historical
		// utilizzare una specie di promiseAll()
		

	// export interface ForcedChannelingRequest {
	// 	workings_to_forced: IWorkingToForce[];
	// }

	// export interface IWorkingToForce {
	// 	workings_list: string[];
	// 	type: WorkingTypes;
	// 	group: string;
	// 	user_info: User;
	// }		

	
	/**
	 * prende una lista di pratiche, 
	 * e le canalizza in base al gruppo
	 * 
	 * @param {workingList} WorkingModel[]
	 * @param {string} group
	 * @param {User} user
	 * @param {boolean} isArchived
	 * @param {boolean} isForGlassPractice
	 * @returns {Observable<Response>}
	 */
	forceChanneling2(
		workingList: WorkingModel[] | DossierWorking[] | CarglassRequestDetail[] | CarglassRequest[], 
		group: string, 
		user: User, 
		isArchived: boolean, 
		isForGlassPractice: boolean = false
	): Observable<Response> {

		let workings2Force: IWorkingToForce[] = [];
		
		// bisogna dividere per tipologia,
		// l'array deve avere solo 4 elementi, 
		// in base alle 4 tipologie della pratica.
		// l'API è fatta così, lo so che non ha senso...
		const wt = WorkingTypes;
		const obj = { group: group, user_info: user };
		
		const map1: Map<WorkingTypes, IWorkingToForce> = new Map();
		map1.set(wt.MECHANIC,       new WorkingToForce({ ...obj, type: wt.MECHANIC }));
		map1.set(wt.CARBODY,        new WorkingToForce({ ...obj, type: wt.CARBODY }));
		map1.set(wt.GLASS,          new WorkingToForce({ ...obj, type: wt.GLASS }));
		map1.set(wt.ADMINISTRATION, new WorkingToForce({ ...obj, type: wt.ADMINISTRATION }));

		// organizza le pratiche in base al tipo
		for (let x of workingList) {
			if (map1.has(x.type)) {
				map1.get(x.type).workings_list.push(x.id);
			}
		}
		
		// la mappa con i 4 tipi diventa un array di 4 elementi
		map1.forEach(x => workings2Force.push(x));

		// TODO
		// bisogna capire se possiamo gestirle separatamente
		const request: ForcedChannelingRequest = {
			workings_to_forced: [
				...workings2Force.filter(x => !Utilities.isEmpty(x.workings_list)),
			]
		};

		// const url = (isForGlassPractice ? `${this.environment.CARGLASS}/channeling` : `${this.baseUrl}`) + '/association/forced'
		let url = '';
		if (isForGlassPractice) {
			url = this.getBaseURL(EModuleType.CARGLASS, isArchived) + '/channeling';
		} else {
			url = this.getBaseURL(EModuleType.AUTHORITY, isArchived) + '/working_channeling';
		}
		url += '/association/forced';

		return this.httpAuthService.post(url , request, this.redirectUrl).pipe(
			tap(response => {
				if (!response.ok) {
					throw response;
				}
			}), map(response => response.json()),
			catchError(err => throwError(err))
		);
	}

	/**
	 * questa è la funzione vecchia
	 * e le canalizza in base al gruppo
	 * 
	 * @param {ForcedChannelingRequest} request
	 * @param {boolean} isForGlassPractice
	 * @returns {Observable<Response>}
	 */
	forceChanneling(request: ForcedChannelingRequest, isForGlassPractice?: boolean): Observable<Response> {
		return this.httpAuthService.post((isForGlassPractice ? `${this.environment.CARGLASS}/channeling` : `${this.baseUrl}`) + '/association/forced', request, this.redirectUrl).pipe(
			tap(response => {
				if (!response.ok) {
					throw response;
				}
			}), map(response => response.json()),
			catchError(err => throwError(err))
		);
	}

	getRequestForForcedChanneling(
		userAndGroup: { group: UserGroup, user: User },
		// TODO
		// questa va cambiata per passare tutto WorkingModel
		forcedChannelingWorkings: { workingId: string, workingType?: WorkingTypes }[],
		workingTypes: WorkingTypes[]): ForcedChannelingRequest {
		const request: ForcedChannelingRequest = {workings_to_forced: []};
		workingTypes.forEach(workingType => {
			if (forcedChannelingWorkings.some(forcedChannelingWorking => forcedChannelingWorking.workingType === workingType)) {
				request.workings_to_forced.push({
					group: userAndGroup.group.user_group,
					user_info: userAndGroup.user,
					type: workingType,
					workings_list: forcedChannelingWorkings.filter(working => working.workingType === workingType).map(working => working.workingId)

					// passare tutto l'oggetto WorkingModel
					// workings_list: forcedChannelingWorkings.filter(working => working.workingType === workingType)
				});
			}
		});
		return request;
	}
}


export interface UserGroup {
	id: string;
	user_group: string;
}

export interface IWorkingToForce {
	workings_list: string[];
	type: WorkingTypes;
	group: string;
	user_info: User;
}

export class WorkingToForce implements IWorkingToForce {
	workings_list	: string[] = [];
	type					: WorkingTypes;
	group					: string;
	user_info			: User;

	constructor(model?: any) {
		this.group				 = model.group;
		this.user_info		 = model.user_info;
		this.workings_list = model.workings_list || [];
		this.type					 = model.type;
	}
}

export interface ForcedChannelingRequest {
	// l'array contiene al max 4 oggetti
	// 1 per ogni tipo MECHANIC, CARBODY, GLASS, ADMINISTRATION,
	// e $workings_list contiene le pratiche di quel tipo, da canalizzare
	workings_to_forced: IWorkingToForce[];
}

export interface User {
	id: string;
	first_name: string;
	last_name: string;
	email: string;
}

enum EModuleType {
	AUTHORITY		= 'authority',
	CARGLASS		= 'carglass',
};


export class ForcedChannelingArchived {
	group				      : string;
	user_info		      : User;
	
	// è una mappa con 4 oggetti
	// ogni oggetto corrisponde ad un tipo
	workingListByType : {
		type				: WorkingTypes;
		workingList : WorkingModel[];
	}

	constructor(model?: any) {
		
		if (U.isEmpty(model)) {
			return;
		}
		
		// this.workingList = model.workingList;
		// this.type				 = model.type;
		this.group			 = model.group;
		this.user_info	 = model.user_info;
	}
}